import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import cx from "classnames";
import styles from "../../../styles/CXpages.module.css"
import InternationalBrands from "../../../images/InternationalBrands.svg"
import Image from "next/image"

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 600,
  minWidth:350,
  bgcolor: 'background.paper',
  border: '0px solid #000',
  borderRadius: '16px',
  boxShadow: 24,
  p: 4,
  overflow:'scroll',
};

export default function BrandsModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button style={{ padding:"5px 20px" }} onClick={handleOpen}>بیشتر بخوانید</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
            <div dir="rtl">
              <h5 className={cx(styles.innerHeadings , "mb-3" )}>چالش عرضه کالای با کیفیت در دیجی کالا</h5>
              <p>یکی از پیامدهای تحریم‌های بین‌المللی و همچنین ممنوعیت واردات در چند سال گذشته، افزایش عرضه کالاهای ناشناخته، غیر اصل و مشابه برندهای اصلی بوده است که بر تعداد کالاهای غیر اصل و نیز کیفیت کالاها تأثیر گذاشته است.</p>
              <Image src={InternationalBrands}  alt="International Brands Trend" className='my-4 w-100 h-auto'/>
              <div className={cx(styles.pinkContainer , "my-4")}>
                <p>روند سهم برندهای مختلف از کالاهای خریداری شده توسط مشتریان دیجی‌کالا</p>
              </div>
            </div>
        </Box>
      </Modal>
    </div>
  );
}